import { getPortalId } from '../utils/getPortalId';
import { apiClientWithMiddleware } from '../utils/API';
import { dataFetchingErrorHandler } from '../errors/dataFetchingErrorHandler';
const navPersonaApiClient = apiClientWithMiddleware();
const URL_SLUG = `navpersona/depot/v1/attribute/`;
const setAttribute = (attributeName, value, userId) => {
  const portalId = getPortalId();
  const endpoint = userId === undefined ? `${URL_SLUG}${portalId}` : `${URL_SLUG}${portalId}/${userId}`;
  return navPersonaApiClient.post(endpoint, {
    data: {
      personaAttributeName: attributeName,
      personaAttributeValue: value
    },
    query: {
      portalId
    }
  }).catch(dataFetchingErrorHandler('Failed to set attribute on nav persona', {
    defaultResult: null
  }));
};
export const navPersonaService = {
  setAttribute
};